import { useState, useEffect } from 'react';
import { Pane, Card, Heading, Button, majorScale} from 'evergreen-ui';
import { EditIcon, CircleArrowLeftIcon } from 'evergreen-ui';
import GuestsTable from './GuestsTable';
import GuestPeiComment from './GuestPeiComment';
import AddGuestForm from './AddGuestForm';
import { getGuests } from '../services/guestsServices';

const Guests = ({guests, setGuests, isDirector}) => {
    const [isEditing, setIsEditing] = useState(false);
    const [newGuest, setNewGuest] = useState({ nome: '', cognome: '', data_nascita: '', sesso: '', luogo_nascita: '', residenza: '', domicilio: '', motivazione: '' });
    const [editingGuestIndex, setEditingGuestIndex] = useState(null);

    useEffect(() => {
        const fetchGuests = async () => {
            try {
                const guestsData = await getGuests();
                setGuests(guestsData);
            } catch (error) {
                console.error('Errore nel recupero degli ospiti:', error);
            }
        };

        fetchGuests();
    }, [setGuests]);

    const handleExitEditMode = () => {
        setIsEditing(false);
        setEditingGuestIndex(null);
    };

    if (!isEditing) {
        return (
            <Card elevation={2} padding={24} marginBottom={32} background="tint1">
                <Heading size={700} marginBottom={16}>
                    Ospiti
                </Heading>
                <GuestsTable
                    guests={guests}
                    setGuests={setGuests}
                    editingGuestIndex={null}
                    setEditingGuestIndex={() => {}}
                    isEditing={false}
                />
                {isDirector && (
                    <Button appearance="primary" intent="success" marginTop={16} onClick={() => setIsEditing(true)}>
                        Modifica <EditIcon marginLeft={8} />
                    </Button>
                )}
                <GuestPeiComment guests={guests} setGuests={setGuests} />
            </Card>
        );
    }

    return (
        <Pane>
            <Card elevation={2} padding={24} marginBottom={32} background="tint1">
                <Heading size={700} marginBottom={16}>
                    Gestione ospiti
                </Heading>
                <GuestsTable
                    guests={guests}
                    setGuests={setGuests}
                    editingGuestIndex={editingGuestIndex}
                    setEditingGuestIndex={setEditingGuestIndex}
                    isEditing={true}
                    isDirector={isDirector}
                />
                <AddGuestForm
                    newGuest={newGuest}
                    setGuests={setGuests}
                    setNewGuest={setNewGuest}
                />
                <Button appearance="primary" intent="success" marginTop={majorScale(2)} onClick={handleExitEditMode} width="9.1rem">
                    Torna indietro <CircleArrowLeftIcon marginLeft={8} />
                </Button>
            </Card>
        </Pane>
    );
};

export default Guests;